import electionApi from '~/clientApis/electionApi';
import { showMessageModal } from '~/clientUtils/showMessageModal';
import { getStore } from '~/mobx/AppStore';

const getElectionById = async () => {
    const { generalSettingsStore } = getStore();
    const { selectedElectionId } = generalSettingsStore;

    if (!selectedElectionId) {
        return;
    }

    generalSettingsStore.setIsLoadingElectionData(true);

    try {
        const election = await electionApi.getElectionById(selectedElectionId);
        generalSettingsStore.setSelectedElectionData(election);
    } catch (error) {
        showMessageModal('error', 'Error fetching election data');
        throw error;
    } finally {
        generalSettingsStore.setIsLoadingElectionData(false);
    }
};

export default getElectionById;
